
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"8","fill":"#969FB3","stroke":"#FFF","stroke-width":".9"}}),_c('path',{attrs:{"d":"M12.72 15.87c-.18 0-.27-.18-.27-.27l1.53-4.77c.09-.09.18-.18.27-.18h1.98c.18 0 .27.18.18.36l-1.17 3.15h2.43c.18 0 .27.27.18.36l-4.23 5.04c-.18.18-.45 0-.45-.27l1.17-3.42h-1.62z","fill":"#FFF"}})])
          )
        }
      }
    